<div class="theme-toggle-container">
	<ng-container [ngSwitch]="activeTheme">
		<mat-icon *ngSwitchCase="theme.DARK"
				  class="icon"
				  [matTooltip]="'Switch to Light Mode'"
				  (click)="toggleTheme()"
		>dark_mode</mat-icon>

		<mat-icon *ngSwitchCase="theme.LIGHT"
				  class="icon"
				  [matTooltip]="'Switch to Dark Mode'"
				  (click)="toggleTheme()"
		>light_mode</mat-icon>
	</ng-container>
</div>
